import { useTranslation } from 'react-i18next';
import { Button } from '@xxtract/ui';

interface InvoiceBulkBarProps {
  selectedCount: number;
  onDownloadZip: () => void;
  onDeselect: () => void;
  isDownloading?: boolean;
}

/** Sticky bulk-action bar, shown only while one or more invoices are selected. */
export function InvoiceBulkBar({ selectedCount, onDownloadZip, onDeselect, isDownloading = false }: InvoiceBulkBarProps) {
  const { t } = useTranslation();

  if (selectedCount === 0) return null;

  return (
    <div
      data-testid="invoice-bulk-bar"
      role="toolbar"
      aria-label={t('invoices.bulkBar.label')}
      className="sticky bottom-4 flex items-center gap-3 rounded-xl border border-[var(--border)] bg-[var(--background)] px-4 py-3 shadow-[var(--card-shadow)]"
    >
      <span className="text-sm font-semibold text-[var(--foreground)]">
        {t('invoices.bulkBar.selectedCount', { count: selectedCount })}
      </span>
      <Button variant="secondary" size="sm" onClick={onDownloadZip} disabled={isDownloading}>
        <span className="material-symbols-outlined text-[16px]" aria-hidden="true">folder_zip</span>
        {t('invoices.bulkBar.downloadZip')}
      </Button>
      <Button variant="ghost" size="sm" onClick={onDeselect}>
        {t('invoices.bulkBar.deselect')}
      </Button>
    </div>
  );
}
